import Vue from 'vue'
import VueRouter from 'vue-router'

// Our routes
import mics from '@/router/mics'
import { getHomeRouteForLoggedInUser, getUserData, isUserLoggedIn } from '@/auth/utils'
import { canNavigate } from '@/libs/acl/routeProtection'
import AccountsService from '@/api/client/accounts.service'
import store from '@/store'
import axiosIns from '@/libs/axios'
import adsManager from './client/ads-manager'
import properties from './client/properties'
import account from './client/account'
import catalog from './client/catalog'
import management from './admin/management'
import adTypes from './admin/ad-types'
import configuration from './admin/configuration'
import adDebugger from './admin/ad-debugger'
import info from './client/info'
import { authRoutes } from '../../GjirafaFront/script/auth' // onError

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'statistics' } },
    ...authRoutes,
    ...account,
    ...adsManager,
    ...configuration,
    ...catalog,
    ...management,
    ...properties,
    ...adTypes,
    ...mics,
    ...adTypes,
    ...adDebugger,
    ...info,
    // change redirect url for path *
    {
      path: '*',
      redirect: '/error',
    },
  ],
})

// router.onError(error => {
//   if (/loading chunk \d* failed./i.test(error.message) && navigator.onLine) {
//     window.location.reload()
//   }
// })

const routesWithoutAuthorization = [
  '/account/create',
  '/user/emailmismatch',
  '/user/invitationexpired',
  '/error',
]

router.beforeEach(async (to, from, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login', query: { redirectTo: `${window.location.pathname}${window.location.search}` } })

    // If logged in => not authorized
    return next({ name: 'not-authorized' })
  }

  if (to.path === '/user/invitation') {
    const { code } = to.query
    const accountInvitationResponse = await axiosIns.get(`user/invitation?code=${code}`).then(response => response.data)
    if (accountInvitationResponse.emailMisMatch) {
      return next({ name: 'email-mismatch' })
    } if (accountInvitationResponse.invitationExpired) {
      return next({ name: 'invitation-expired' })
    }
    return next(accountInvitationResponse.returnUrl)
  }

  const isInAdminPlatform = to.fullPath.includes('admin')
  if (!to.params.accountId && !isInAdminPlatform && isLoggedIn && !routesWithoutAuthorization.includes(to.path)) {
    await AccountsService.getDefaultAccount().then(response => {
      if (response === false) {
        localStorage.clear()
        window.location.href = '/'
      }
      if (response.id == null) { next({ name: 'create' }) } else { next({ name: 'statistics', params: { accountId: response.id } }) }
      // the above state is not available here, since it
      // it is resolved asynchronously in the store action
    }, error => {
      console.log(error)
      // handle error here
    })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData))
  }
  // Change sidebar items to match platform based on pathname
  const adminPlatform = store.getters['verticalMenu/adminPlatform']
  if ((isInAdminPlatform && !adminPlatform) || (!isInAdminPlatform && adminPlatform)) { store.commit('verticalMenu/changePlatform', !adminPlatform) }
  if (to.path === '/login' && isLoggedIn) {
    next(false)
    return router.go()
  }
  return next()
})

export default router
